import { differenceInCalendarDays, format } from 'date-fns';
import { getDateFnsLocale } from '../../../utils/formatters';

const DATE_PATTERNS = { pt: 'dd/MM/yyyy', es: 'dd/MM/yyyy', en: 'MM/dd/yyyy' };

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

// Replica o padrão do WhatsApp: hoje → hora; ontem → rótulo traduzido; entre 2 e
// 6 dias atrás → dia da semana (ex.: "Sexta-feira"); mais antigo → data — sempre
// no idioma ativo do usuário (`language`, de `i18n.language`), não fixo em pt-BR.
export const formatMessageTime = (date, t, language = 'pt') => {
  if (!date) return '';
  const parsed = new Date(date);
  const daysAgo = differenceInCalendarDays(new Date(), parsed);
  const locale = getDateFnsLocale(language);
  const datePattern = DATE_PATTERNS[language] || DATE_PATTERNS.pt;

  if (daysAgo <= 0) return format(parsed, 'HH:mm');
  if (daysAgo === 1) return t('leads.yesterday');
  if (daysAgo <= 6) return capitalize(format(parsed, 'EEEE', { locale }));
  return format(parsed, datePattern, { locale });
};
